export const partnerOperationsInitValue = {
  data: {
    societyId: '',
    societyName: '',
    partner: null,
    totalOperations: 0,
    operations: [],
    sharesTitles: [],
    titleDocument: undefined,
    page: 1,
    rowsPerPage: 10,
    expandedRows: new Set<number>(),
    hasTitlesEnabled: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleExpandRow: () => {},
  },
};
